import type {
    Candidate,
    DemocraticCountdown,
    OperationDeviceCoupon,
    OperationRepeat
} from 'shared/types'
import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {
    coupons: Array<OperationDeviceCoupon>,
    showTuto: boolean,
    operationRepeat?: OperationRepeat,
    candidates: Array<Candidate>,
    lastUpdate: string,
    myVote?: Candidate,
    countdownData?: DemocraticCountdown,
    dataElectionLoading?: boolean,
    voteError?: string,
    error?: string,
    networkError?: any
}

export const initialState: State = {
    coupons: [],
    showTuto: true,
    candidates: [],
    lastUpdate: ''
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_HOMEPAGE_RESPONSE':
            const { marketingAnimations } = action.data
            const find =
                marketingAnimations &&
                marketingAnimations.primary &&
                marketingAnimations.primary.find(e => {
                    return !!e.operationRepeat
                })
            const operationRepeatPrimary = find
                ? find.operationRepeat
                : undefined
            const operationRepeatWidget =
                marketingAnimations && marketingAnimations.widget
                    ? marketingAnimations.widget.operationRepeat
                    : undefined
            const operationRepeat =
                operationRepeatPrimary || operationRepeatWidget
            return {
                ...state,
                operationRepeat
            }
        case 'DEMOCRATIC_BURGER_SET_OPERATION_REPEAT':
            return { ...state, operationRepeat: action.operationRepeat }
        case 'PAGE_DATA_DEMOCRATIC_BURGER_COUPONS_RESPONSE':
            return {
                ...state,
                ...action.data,
                showTuto: false,
                networkError: undefined,
                error: undefined
            }
        case 'PAGE_DATA_DEMOCRATIC_BURGER_ELECTION_LOADING':
            return {
                ...state,
                ...action
            }
        case 'PAGE_DATA_DEMOCRATIC_BURGER_ELECTION_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataElectionLoading: false,
                error: undefined,
                networkError: undefined
            }
        case 'DEMOCRATIC_BURGER_PAGE_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'DEMOCRATIC_BURGER_VOTE_SUCCESS': {
            return {
                ...state,
                myVote: action.myVote
            }
        }
        case 'DEMOCRATIC_BURGER_VOTE_ERROR': {
            return {
                ...state,
                voteError: action.voteError
            }
        }
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.pages.delivery)
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
